import appCustomer from "../../views/appCustomer.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("customer", {
    url: "customer/:id",
    parent: "app",
    views: {
      view: {
        template: appCustomer,
      },
    },
    data: { title: "Customer" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/customer/customer.urls.js